import { createFileRoute } from "@tanstack/react-router";

import { type ChildRouteContext } from "@/root";
import {
  redirectIfModuleDisabled,
  throwIfHasNoPermission,
} from "@/utils/permissions";

import MoodSettingsForm from "../../../components/settings/MoodSettingsForm";

export const Route = createFileRoute("/admin/_panel/_settings/settings/mood")({
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("mood", context.tenant.modules);

    throwIfHasNoPermission(context.user, "mood.mood-settings.view");

    return {} satisfies ChildRouteContext;
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <MoodSettingsForm />;
}
